export { paginationClasses, PaginationItem } from "@mui/material";

import {
  Pagination as MuiPagination,
  PaginationProps as MuiPaginationProps,
  PaginationItem,
  PaginationRenderItemParams,
} from "@mui/material";
import React from "react";

export type PaginationProps = Pick<
  MuiPaginationProps,
  | "page"
  | "count"
  | "hideNextButton"
  | "hidePrevButton"
  | "showFirstButton"
  | "showLastButton"
  | "sx"
  | "onChange"
  | "siblingCount"
  | "boundaryCount"
> & {
  customLabels?: (string | number)[];
};

export const Pagination = ({ customLabels, sx, ...props }: PaginationProps) => {
  const renderItem = customLabels
    ? (item: PaginationRenderItemParams) => {
        const label =
          item.page && customLabels[item.page - 1]
            ? customLabels[item.page - 1]
            : item.page;
        return <PaginationItem {...item} page={label} />;
      }
    : undefined;

  return (
    <MuiPagination
      {...props}
      renderItem={renderItem}
      sx={{ width: "fit-content", margin: "2rem auto", ...sx }}
    />
  );
};

Pagination.displayName = "Pagination";

export default Pagination;
